import "./style.css";
export const Loader = () => {
  return (
    <div class="🤚">
      <div class="👉"></div>
      <div class="👉"></div>
      <div class="👉"></div>
      <div class="👉"></div>
      <div class="🌴"></div>
      <div class="👍"></div>
    </div>
  );
};
